/*
 * Copyright (c) 2022.
 *
 * Robert Siennicki (robert.siennicki@carsmile.pl)
 * Carsmile (https://carsmile.pl)
 */

import axios from "axios";
import history from '../libs/history';
import {query_decode, query_encode, scroll_to} from "../helpers/functions";
import PluginNoUiSlider from "../plugins/nouislider";
import App from "../helpers/app";
import initPartialOffersConfigEvents from "../partials/offers-config";

$(function(){
    const $page = $('.page-advanced-search-form');
    if(!$page.length){
        return;
    }

    let $offerFirst = true;
    let $offerRequest = null;
    let $facetRequest = null;
    let $lastFacetForm = null;
    function initSearchFacets() {
        let $section = $('.section-advanced-search-facets');
        let $form = $section.find('form');
        let $button;

        if ($facetRequest) {
            $facetRequest.cancel();
        }

        if($lastFacetForm === $form.serialize()){
            return;
        }
        $lastFacetForm = $form.serialize();

        $facetRequest = axios.CancelToken.source();

        let $submitLoader = $section.find('[data-lead-send]');
        let $filterLoader = $section.find('.filter-container');
        App.loader.init($submitLoader, 'button');
        App.loader.init($filterLoader, 'button');

        axios.post('/konfigurator/filtry', $lastFacetForm, {cancelToken: $facetRequest.token})
            .then(function (response) {
                App.loader.end($submitLoader);
                App.loader.end($filterLoader);

                $section.find('[data-search-tags-container]').empty();

                if(response.data.productsCount){
                    $section.find('[data-search-count-isset]').show();
                    $section.find('[data-search-count-empty]').hide();
                }else{
                    $section.find('[data-search-count-isset]').hide();
                    $section.find('[data-search-count-empty]').show();
                }
                $section.find('[data-offers-url]').attr('data-offers-url', response.data.offersUrl);
                $section.find('[data-search-count]').html(response.data.productsCount);
                $section.find('[data-search-price]').html(response.data.lowestPrice ?? '-');

                $form.find('[data-facet-form-id][data-facet-filled]').addClass('disabled');

                $button = $section.find('[data-facet-form-id="financial"]');
                $button.addClass('selected');
                $button.find('.facet-selected-count').html(2);

                $button = $section.find('[data-facet-form-id="price"]');
                $button.addClass('selected');
                $button.find('.facet-selected-count').html(1);

                let selectedAll = [];

                $.each(response.data.facets, function (facetIndex, facet){
                    $button = $form.find('[data-facet-form-id="'+facet.key+'"]');
                    let $fields = $form.find('[data-facet="'+facet.key+'"]');
                    let $panel = $button.closest('[data-panel]');
                    let $tagContainer = $panel.find('[data-search-tags-container]');

                    $button.removeClass('disabled');

                    let selected = [];
                    $button.removeClass('selected');

                    if(facet.items.length){
                        $.each(facet.items, function (valueIndex, valueItem){
                            if(!valueItem.checked){
                                return;
                            }
                            selected.push(valueItem);
                            $tagContainer.append(`
                                <div data-tag-delete="`+facet.key+`.`+valueItem.value+`" class="tw-flex tw-items-center tw-text-xs tw-text-theme-gray-pinked tw-rounded tw-border tw-border-solid tw-border-theme-gray-pinked tw-px-3 tw-py-1.5 tw-mr-1 tw-mb-2 tw-cursor-pointer">
                                    <div class="tw-flex tw-leading-none tw-uppercase">`+valueItem.label+`</div>
                                    <div class="tw-flex tw-ml-2"><i class="ic ic-icon-close tw-text-[7px]"></i></div>
                                </div>
                            `)
                        });
                    }else if(facet.type === 'range'){
                        if(facet.extra.min < (facet.values[0][0] ?? '')){
                            selected.push(facet.values[0][0] ?? '');
                            $tagContainer.append(`
                                <div data-tag-delete="`+facet.key+`" class="tw-flex tw-items-center tw-text-xs tw-text-theme-gray-pinked tw-rounded tw-border tw-border-solid tw-border-theme-gray-pinked tw-px-3 tw-py-1.5 tw-mr-1 tw-mb-2 tw-cursor-pointer">
                                    <div class="tw-flex tw-leading-none tw-uppercase"></div>
                                    <div class="tw-flex tw-ml-2"><i class="ic ic-icon-close tw-text-[7px]"></i></div>
                                </div>
                            `)
                        }

                        if(facet.extra.max > (facet.values[1][0] ?? '')){
                            selected.push(facet.values[1][0] ?? '');
                            $tagContainer.append(`
                                <div data-tag-delete="`+facet.key+`" class="tw-flex tw-items-center tw-text-xs tw-text-theme-gray-pinked tw-rounded tw-border tw-border-solid tw-border-theme-gray-pinked tw-px-3 tw-py-1.5 tw-mr-1 tw-mb-2 tw-cursor-pointer">
                                    <div class="tw-flex tw-leading-none tw-uppercase"></div>
                                    <div class="tw-flex tw-ml-2"><i class="ic ic-icon-close tw-text-[7px]"></i></div>
                                </div>
                            `)
                        }
                    }

                    if(selected.length){
                        selectedAll = $.extend(selectedAll, selected);
                        $button.addClass('selected');
                        $button.find('.facet-selected-count').html(selected.length);
                    }

                    if($fields.length){
                        let filterItems = facet.extra.filtered ?? true;

                        $fields.each(function(){
                            let $field = $(this);
                            switch($field.data('facet-type')){
                                case 'nouislider':
                                    let slider = $field.next().get(0);
                                    let step = Math.ceil(parseFloat(facet.extra.step ?? 100));
                                    let min = Math.ceil(parseFloat(facet.extra.min));
                                    let max = Math.ceil(parseFloat(facet.extra.max));
                                    let options = {
                                        connect: true,
                                        step: step,
                                        start: [$field.attr('value').split(':')[0] ?? min, $field.attr('value').split(':')[1] ?? max],
                                        range: {
                                            min: min,
                                            max: max
                                        }
                                    };

                                    if(typeof slider === 'undefined'){
                                        slider = PluginNoUiSlider.create($field, {plugin: options, connectedInput: [
                                            $field.closest('.config-group').find('.slider-preview.'+facet.key+'-from-preview .preview-input'),
                                            $field.closest('.config-group').find('.slider-preview.'+facet.key+'-to-preview .preview-input')
                                        ]});
                                    }else{
                                        slider.noUiSlider.updateOptions(options, false);
                                    }

                                    break;
                                case 'select2':
                                    if(!$field.data('select2')){
                                        let $fieldOptions = {};
                                        $fieldOptions['placeholder'] = $field.data('placeholder');
                                        $fieldOptions['allowClear'] = true;
                                        if(!$field.attr('multiple')){
                                            $fieldOptions['minimumResultsForSearch'] = Infinity;
                                        }
                                        $field.select2($fieldOptions);
                                    }

                                    $field.find('option').remove();
                                    if(!$field.attr('multiple')){
                                        $field.append('<option></option>');
                                    }

                                    if(facet.items.length){
                                        $.each(facet.items, function (valueIndex, valueItem){
                                            let emptyFacetValue = filterItems && valueItem.filtered.count === 0;
                                            if(emptyFacetValue){
                                                return true;
                                            }

                                            $field.append(`
                                                <option value="`+valueItem.value+`" `+(valueItem.checked ? 'selected' : '')+`>`+valueItem.label+`</option>
                                            `);
                                        });
                                    }
                                    break;
                                case 'swiper':

                                    break;
                                case 'checkbox':
                                    let lastVehicleClass;
                                    $field.empty();
                                    if(facet.items.length){
                                        $.each(facet.items, function (valueIndex, valueItem){
                                            let emptyFacetValue = filterItems && valueItem.filtered.count === 0;

                                            if(facet.key === 'bodyType'){
                                                let nowVehicleClass = valueItem.extra.vehicle_class ?? '';
                                                lastVehicleClass = lastVehicleClass ?? nowVehicleClass;

                                                $field.append(`
                                                    <div>
                                                        <div class="default-checkbox `+ (nowVehicleClass !== lastVehicleClass ? 'tw-mt-5' : '') +`">
                                                            <input type="checkbox" 
                                                                `+(emptyFacetValue ? 'disabled' : '')+`
                                                                value="`+valueItem.value+`" name="`+facet.key+`[]" 
                                                                id="facet-checkbox-`+facet.key+`-`+valueItem.value+`"
                                                                `+(valueItem.checked ? 'checked' : '')+`
                                                            >
                                                            <label class="!tw-top-0" for="facet-checkbox-`+facet.key+`-`+valueItem.value+`"></label>
                                                            <label class="!tw-ml-5" for="facet-checkbox-`+facet.key+`-`+valueItem.value+`">`+valueItem.label+`</label>
                                                        </div>
                                                    </div>
                                                `)

                                                lastVehicleClass = nowVehicleClass;
                                            }else{
                                                $field.append(`
                                                    <div>
                                                        <div class="default-checkbox">
                                                            <input type="checkbox" 
                                                                `+(emptyFacetValue ? 'disabled' : '')+`
                                                                value="`+valueItem.value+`" name="`+facet.key+`[]" 
                                                                id="facet-checkbox-`+facet.key+`-`+valueItem.value+`"
                                                                `+(valueItem.checked ? 'checked' : '')+`
                                                            >
                                                            <label class="!tw-top-0" for="facet-checkbox-`+facet.key+`-`+valueItem.value+`"></label>
                                                            <label class="!tw-ml-5" for="facet-checkbox-`+facet.key+`-`+valueItem.value+`">`+valueItem.label+`</label>
                                                        </div>
                                                    </div>
                                                `)
                                            }
                                        });
                                    }

                                    break;
                                case 'radio':
                                    $field.empty();
                                    if(facet.items.length){
                                        $.each(facet.items, function (valueIndex, valueItem){
                                            let emptyFacetValue = filterItems && valueItem.filtered.count === 0;
                                            if(emptyFacetValue){
                                                return true;
                                            }

                                            $field.append(`
                                                <div class="default-radio tw-mr-6 tw-mb-2">
                                                    <input type="radio" 
                                                        value="`+valueItem.value+`" name="`+facet.key+`" 
                                                        id="facet-radio-`+facet.key+`-`+valueItem.value+`"
                                                        `+(valueItem.checked ? 'checked' : '')+`
                                                    >
                                                    <label for="facet-radio-`+facet.key+`-`+valueItem.value+`"></label>
                                                    <label for="facet-radio-`+facet.key+`-`+valueItem.value+`">`+valueItem.label+`</label>
                                                </div>
                                            `)
                                        });
                                    }

                                    break;
                            }
                        });
                    }
                });

                if(!selectedAll.length){
                    $section.find('[data-search-price-container]').hide();
                }

                updateLocation(response);
            })
            .catch(function () {

            });
    }

    function updateLocation(response){
        let $section = $('.section-advanced-search-facets');
        let $form = $section.find('form');
        let oldParams = query_decode(history.location.search.substr(1));
        let params = query_decode($form.serialize());

        $.each(params, function (k,v){
            if((v[1] ?? '').indexOf(':') !== -1){
                params[k] = '';
                params[k+'From'] = v[1].split(':')[0] ?? '';
                params[k+'To'] = v[1].split(':')[1] ?? '';
            }
        });

        params.sort = oldParams.sort;
        params.page = '';
        params.count = response.data.productsCount;

        history.pushParams(params);
    }

    function initSearchCount() {
        let $section = $('.section-advanced-search-facets');
        let $form = $section.find('form');

        if ($facetRequest) {
            $facetRequest.cancel();
        }

        $facetRequest = axios.CancelToken.source();

        let $countLoader = $section.find('.filter-side-over [data-search-count]').closest('.btn');
        App.loader.init($countLoader, 'button');

        axios.post('/konfigurator/dostepne', $form.serialize(), {cancelToken: $facetRequest.token})
            .then(function (response) {
                App.loader.end($countLoader);

                $section.find('[data-search-count]').html(response.data.productsCount);

                updateLocation(response);
            })
            .catch(function () {

            });
    }

    // function getOffers(url, append){
    //     if ($offerRequest) {
    //         $offerRequest.cancel();
    //     }
    //
    //     $offerRequest = axios.CancelToken.source();
    //
    //     axios.get(url, {cancelToken: $offerRequest.token})
    //         .then(function (response){
    //             showOffers(response.data, append);
    //         })
    //         .catch(function () {
    //
    //         });
    // }
    //
    // function showOffers(html, append){
    //     let section = $('.section-offers-list');
    //     let offersSection = $(html).find('.section-offers-list');
    //
    //     App.registerPlugins(offersSection);
    //
    //     if(append){
    //         section.find('.offers-list').append(offersSection.find('.offers-list .offer-item'));
    //
    //         section.find('.show-more').empty();
    //         section.find('.show-more').append(offersSection.find('.show-more .btn'));
    //     }else{
    //         section.empty();
    //         section.append(offersSection.children());
    //
    //         initOffersEvent();
    //     }
    // }
    //
    // function initOffersEvent(){
    //     let $section = $('.section-offers-filters');
    //     if(!$section.length){
    //         return;
    //     }
    //
    //     // $('.section-offers-list [name="sort"]').select2({
    //     //     minimumResultsForSearch: Infinity
    //     // });
    // }
    //
    // initOffersEvent();

    function initSearch(){
        let $section = $('.section-advanced-search-facets');
        if(!$section.length){
            return;
        }

        initPartialOffersConfigEvents();

        let $form = $('.section-advanced-search-facets form');
        let $sideOverBackdrop = $section.find('.filter-side-over-backdrop');
        let $sideOver = $section.find('.filter-side-over');

        $form.on('click', '[data-panel-delete]', function(){
            $(this).closest('[data-panel]').find('[data-tag-delete]').click();
        });

        $form.on('click', '[data-tag-delete]', function(){
            let [key, value] = $(this).data('tag-delete').split('.');
            $form.find('[type="radio"][name="'+key+'"]'+(value ? '[value="'+value+'"]' : '')+':checked').prop('checked', false);
            $form.find('[type="checkbox"][name="'+key+'[]"]'+(value ? '[value="'+value+'"]' : '')+':checked').prop('checked', false);
            $form.find('select[name="'+key+'[]"] option'+(value ? '[value="'+value+'"]' : '')+':checked').remove();
            $form.find('[data-facet-type="nouislider"][name="'+key+'"]').val('0:100000000').change();
            if($form.find('[data-facet-type="nouislider"][name="'+key+'"]').next().get(0) && typeof $form.find('[data-facet-type="nouislider"][name="'+key+'"]').next().get(0).noUiSlider !== 'undefined'){
                $form.find('[data-facet-type="nouislider"][name="'+key+'"]').next().get(0).noUiSlider.updateOptions({ start: [0, 100000000] });
            }

            if($(this).is('[data-sideover-clean]')){
                initSearchCount();
            }else{
                initSearchFacets();
            }
        });

        $form.on('change', 'select, input', function (){
            initSearchCount();
        });

        $form.submit(function (e){
            e.preventDefault();
        });

        history.listen(({ action, location }) => {
            if($offerFirst){
                $offerFirst = false;
                return;
            }

            // getOffers(location.pathname+location.search);
        });

        $section.on('click', '[data-lead-send]', function (e){
            let errors = false;
            $('[data-required]').each(function(){
                let checked = $(this).find('[name="' + $(this).data('required') + '"]:checked').length;
                if(!checked){
                    errors = true;
                    $(this).find('[data-required-message]').show();
                }
            });
            if(errors){
                scroll_to($('[data-required-message]:visible').first().closest('[data-required]'));
                return;
            }

            App.loader.init($(this), 'button');
            window.location.href = $(this).data('without-lead') && $(this).data('offers-url')
                ? $(this).data('offers-url')
                : '/model/lead/search?' + $.param({'offerFilters': query_decode(history.location.search.substr(1))});
        });

        $section.on('click', '[data-reset-filters]', function (e){
            e.preventDefault();

            $section.find('[data-facet-type="select2"]').val('').change();
            $section.find('[data-facet-type="nouislider"]').val('0:100000000').change();
        });

        $section.on('change', '[name="sort"]', function (){
            let $field = $(this);
            history.pushParams({sort: $field.val()});
        });

        $section.on('click', '[data-page]', function (){
            let $btn = $(this);
            let $page = $btn.data('page');
            let location = history.location;
            let url = location.pathname+location.search;
            url += url.indexOf('?')===-1 ? '?' : '&';
            url += 'page='+$page;

            // getOffers(url, true);
        });

        $section.find('[data-sideover-close]').click(function (){
            initSearchFacets();

            let $icons = $section.find('.facet-button');
            $icons.removeClass('active');

            $sideOverBackdrop.hide();
            $sideOver.addClass('tw-translate-x-full');

            $('html').removeClass('window-scroll-disabled');
        });

        $section.find('.facet-button').click(function (){
            let $icon = $(this);
            let $icons = $section.find('.facet-button');
            let $panel = $section.find('.facet-form[data-facet-form="'+$icon.data('facet-form-id')+'"]');

            if($icon.hasClass('disabled') || $section.find('[data-lead-send]').hasClass('is-loading')){
                return;
            }

            $icons.removeClass('active');
            $icon.addClass('active');

            $sideOver.find('[data-sideover-title]').html($icon.find('[data-facet-title]').text());
            $sideOver.find('[data-sideover-subtitle]').html($icon.find('[data-facet-subtitle]').text());
            $sideOver.find('[data-sideover-clean]')
                .data('tag-delete', $icon.data('facet-form-id'))
                .attr('data-tag-delete', $icon.data('facet-form-id'));

            if($icon.closest('[data-panel]').is('[data-panel-canClear="0"]')){
                $sideOver.find('[data-sideover-clean]').hide();
            }else{
                $sideOver.find('[data-sideover-clean]').show()
            }

            $section.find('.facet-form').hide();
            $panel.show();

            $sideOverBackdrop.show();
            $sideOver.removeClass('tw-translate-x-full');

            $('html').addClass('window-scroll-disabled');

            if($panel.find('.noUi-default-theme').length){
                $panel.find('.noUi-default-theme').each(function(){
                    $(this)[0].noUiSlider.updateOptions({});
                });
            }

            $sideOver.find('[data-plugin-scrollbar]').scrollTop(0);

            App.init($panel);
        });

        initSearchFacets();
    }

    initSearch();
});
